export default {
  title: "Баланс",
  balanceInfo: {
    title: "Баланс туралы ақпарат",
    subtitle:
      "Баланста көрсетілген RC барлық операциялар бойынша есептестірулер жүргізілгеннен кейін шоттағы күтілетін соманы білдіреді.",
    moreDetailSpoiler: {
      ru: [
        {
          title: "Нақты баланс",
          description: [
            {
              type: "text",
              value:
                "Банк арқылы балансты толтыруды, болдырмалған операциялар бойынша қайтарымдарды, клиенттерден есептелген баллдарды қамтиды. Сыйақыны бөлу сценарийлері бойынша баллдарды төлеуді, тариф пен қызметтерді сатып алу бойынша есептеулерді, сондай-ақ «Төлемге резервтелген» сомасын (егер орнатылған болса) шегергендегі сома.",
            },
          ],
        },
        {
          title: "Есептеуді күтуде",
          description: [
            {
              type: "text",
              value:
                "Клиенттерден алынған баллдар, бірақ сіздің нақты балансыңызда есептестіру жүргізу үшін қаражат жеткіліксіздігі себебімен әлі есептелмеген. Сондай-ақ сіздің сандықтандырған клиенттеріңіздің басқа мекемелерге барғаны үшін сыйақы (клиенттік саяхат) да есептеуді күтуде. Егер сіздің клиентіңіз барған мекеменің иесінің шотында қаражат жеткіліксіз болса, күту туындайды.",
            },
          ],
        },
        {
          title: "Есептен шығаруды күтуде",
          description: [
            {
              type: "text",
              value:
                "Қаражат жеткіліксіздігі себебімен әлі есептен шығарылмаған баллдар (сыйақыны бөлу сценарийлері бойынша), сондай-ақ егер мекемеде есептеуді кешіктіру орнатылған болса.",
            },
          ],
        },
        {
          title: "Қаражат алуға болады",
          description: [
            {
              type: "text",
              value:
                "Есептен шығаруды күтетін қаражаттарды, белгіленген депозит сомасын, сондай-ақ «Төлемге резервтелген» сомасын (егер орнатылған болса) шегергендегі нақты баланс.",
            },
          ],
        },
        {
          title: "Төлемге резервтелген",
          description: [
            {
              type: "text",
              value: "Есептестірулер кезеңінде нақты төленетін сома.",
            },
            {
              type: "text",
              value:
                "Айына 2 рет баланс баптауларында кемінде 300 RC және ағымдағы «Қаражат алуға болады» балансынан аспайтын мөлшерде орнатылады. Төлем сомасын орнату үшін қаражат шығаруды баптағыңыз келетін заңды тұлғаның баланс карточкасында «Баптауларды» басыңыз.",
            },
            {
              type: "text",
              value:
                "Егер есептестірулер жүргізілгенге дейін сома орнатылмаған болса және «Қаражат алуға болады» баланс сомасы бойынша қаражат шығару қосылмаған болса, қаражат шығару жүргізілмейді.",
            },
            {
              type: "text",
              value:
                "Баланстан төлем үшін қаражатты есептен шығарудың шамалы күндері - әр айдың 1-5 және 16-20 аралығы. Есеп айырысу шоттарына төлем кабинеттегі баланстан есептен шығарылған күннен бастап 14 күн ішінде жүргізіледі.",
            },
          ],
        },
        {
          title: "Есептеу актісі",
          description: [
            {
              type: "v-text",
              value:
                "Есептеу актілерін және орындалған жұмыстар актілерін қолдау қызметі арқылы алуға болады. Ол үшін RC CITY кабинетінің төменгі оң жақ бұрышындағы кері байланыс нысаны арқылы сұраныс жіберіңіз немесе электрондық поштаға хат жіберіңіз <a class='spoiler-link' href='mailto:hello@rc.city'>hello@rc.city</a>",
            },
            {
              type: "list",
              title: "Сұраныста көрсету керек:",
              list: [
                "ИНН",
                "Заңды тұлғаның атауы",
                "Есептеу актісі қажет кезең немесе орындалған жұмыстар актісі қажет сома",
              ],
            },
          ],
        },
      ],
      noRu: [
        {
          title: "Нақты баланс",
          description: [
            {
              type: "text",
              value:
                "Банк арқылы балансты толтыруды, болдырмалған операциялар бойынша қайтарымдарды, клиенттерден есептелген баллдарды қамтиды. Сыйақыны бөлу сценарийлері бойынша баллдарды төлеуді және тариф пен қызметтерді сатып алу бойынша есептеулерді шегергендегі сома.",
            },
          ],
        },
        {
          title: "Есептеуді күтуде",
          description: [
            {
              type: "text",
              value:
                "Клиенттерден алынған баллдар, бірақ есептестіру жүргізу үшін сіздің нақты балансыңызда қаражат жеткіліксіздігі себебімен әлі есептелмеген. Сондай-ақ сіздің сандықтандырған клиенттеріңіздің басқа мекемелерге барғаны үшін сыйақы (клиенттік саяхат) да есептеуді күтуде. Егер сіздің клиентіңіз барған мекеменің иесінің шотында қаражат жеткіліксіз болса, күту туындайды.",
            },
          ],
        },
        {
          title: "Есептен шығаруды күтуде",
          description: [
            {
              type: "text",
              value:
                "Қаражат жеткіліксіздігі себебімен әлі есептен шығарылмаған баллдар (сыйақыны бөлу сценарийлері бойынша), сондай-ақ егер мекемеде есептеуді кешіктіру орнатылған болса.",
            },
          ],
        },
        {
          title: "Қаражат алуға болады",
          description: [
            {
              type: "text",
              value:
                "Есептен шығаруды күтетін қаражаттарды және белгіленген депозит сомасын шегергендегі нақты баланс.",
            },
          ],
        },
        {
          title: "Есептеу актісі",
          description: [
            {
              type: "v-text",
              value:
                "Есептеу актілерін және орындалған жұмыстар актілерін қолдау қызметі арқылы алуға болады. Ол үшін RC CITY кабинетінің төменгі оң жақ бұрышындағы кері байланыс нысаны арқылы сұраныс жіберіңіз немесе электрондық поштаға хат жіберіңіз <a class='spoiler-link' href='mailto:hello@rc.city'>hello@rc.city</a>",
            },
            {
              type: "list",
              title: "Сұраныста көрсету керек:",
              list: [
                "ИНН",
                "Заңды тұлғаның атауы",
                "Есептеу актісі қажет кезең немесе орындалған жұмыстар актісі қажет сома",
              ],
            },
          ],
        },
      ],
    },
  },
  withdrawalInstructionName: "RC CITY кабинетінен қаражат шығару нұсқаулығы",
  reservedForPayment: "Төлемге резервтелген",
  withdrawalOfFund: "Қаражат шығару",
  power: {
    on: "Қосылған",
    off: "Өшірілген",
  },
  actualBalance: "Нақты баланс",
  expectedCredited: "Есептеуді күтуде",
  expectedDebiting: "Есептен шығаруды күтуде",
  availableWithdrawal: "Қаражат алуға болады",
  statusText: {
    needAdjustPaymentMethod: "Қаражат шығару үшін төлем әдісін баптау керек",
    bySumReservedOnBalance: "Төлемге дейін баланста резервтелген сома бойынша",
    bySumAvailableToWithdrawal:
      "Есептестірулер жүргізілген кездегі «Қаражат алуға болады» сомасы бойынша",
  },

  topupModal: {
    title: "Толтыру сомасын көрсетіңіз",
    entityPayer: "Заңды тұлға - төлеуші",
    topupSum: "Толтыру сомасы",
  },
  createAndDownloadAccount: "Шот құру және жүктеу",
  byReservedSum: "«Төлемге резервтелген» сомасы бойынша",
  byAvailableSum: "«Қаражат алуға болады» сомасы бойынша",
  bySettedSum: "Белгіленген сома бойынша",
  bySettedSumDesc:
    "Қаражат төлемге дейін резервтеледі, оны тариф пен қызметтерді сатып алу үшін пайдалану мүмкін болмайды, өйткені нақты баланс белгіленген мәнге азаяды. Бұл әдіс «Қаражат алуға болады» сомасының мәні 300 RC-ден аз болғанда қолжетімді емес.",
  byAvailableSumDesc:
    "Қаражат төлемі есептестірулер жүргізілген кездегі «Қаражат алуға болады» балансының мәніне тең сомада жүргізіледі, егер ол 300 RC-ден кем емес болса.",
  success: "Сәтті",
  settings: {
    title: "Қаражат шығару баптаулары",
    banner: {
      inProgress: {
        title: "Төлемдер жүргізілуде",
        description: [
          "Төлемдер кезеңінде қаражат шығару баптауларын өзгерту қолжетімді емес.",
          "Келесі төлемге арналған баптауларды ағымдағы қаражат төлеу процесі аяқталғаннан кейін орната аласыз.",
        ],
      },
      inPending: {
        title: "Қаражат төлемі күтілуде",
        description: [
          "Ол келісімшарттың 4.6-тармағына сәйкес жүргізіледі. Баланстан төлем үшін қаражатты есептен шығарудың шамалы күндері - әр айдың 1-5 және 16-20 аралығы. Есеп айырысу шоттарына төлем кабинеттегі баланстан есептен шығарылған күннен бастап 14 күн ішінде жүргізіледі.",
          "Төлемді алудан бас тарту, төлем әдісін өзгерту немесе басқа соманы орнату үшін «Қаражат шығаруды өшіру» батырмасын басыңыз.",
        ],
      },
      inDisabled: {
        title: "Қаражат шығару өшірілген",
        description: [
          "Қаражат шығару үшін төлем әдісін таңдап, баптауларды қолданыңыз. Төлем келісімшарттың 4.6-тармағына сәйкес жүргізіледі.",
          "Баланстан төлем үшін қаражатты есептен шығарудың шамалы күндері - әр айдың 1-5 және 16-20 аралығы. Есеп айырысу шоттарына төлем кабинеттегі баланстан есептен шығарылған күннен бастап 14 күн ішінде жүргізіледі.",
          "Ешнәрсе таңдалмаса, көрсетілген кезеңде осы заңды тұлға үшін қаражат төлемі жүргізілмейді.",
        ],
      },
    },
    paymentMethod: "Төлем әдісі",
    sumToBePaid: "Төлемге арналған сома",
    validSumTobePaidValid:
      "300 RC-ден кем емес және ағымдағы «Қаражат алуға болады» балансының мәнінен аспайтын соманы орнатуға болады",
    entity: "Заңды тұлға",
    notSelectedNoPayment: "Таңдалмаған, төлем жүргізілмейді",
    bank: {
      BIC: "Банк БИК",
      naming: "Банк атауы",
      paymentAccount: "Есеп айырысу шот нөмірі",
      corpAccount: "Корсчет",
      depositAmount: "Депозит сомасы",
      depositAmountHint:
        "Шоттағы минималды қалдық. Қаражатты алу кезінде баланста қалатын сома.",
      changeDetails: "Реквизиттерді өзгерту",
    },
    disableWithdrawal: "Қаражат шығаруды өшіру",
    disabledWithdrawalForDefinEntity:
      "{entityName} заңды тұлғасы үшін қаражат шығару өшірілген",
  },
  editPaymentModal: {
    title: "Банк реквизиттерін немесе депозит сомасын өзгерткіңіз келе ме?",
    subtitle:
      "Өңдеу үшін сіз «Заңды тұлғалар» ішкі бөліміне жіберілесіз. Өзгерістер енгізгеннен кейін жаңа реквизиттер бойынша қаражат шығаруды баптау үшін «Баланс» бетіне оралыңыз.",
    toEdit: "Өңдеуге",
  },
  resetPaymentModal: {
    title: "Қаражат шығару баптауларын болдырмау керек пе?",
    subTitle:
      "«Ия, болдырмау» батырмасын басқанда қаражат шығару баптаулары қалпына келтіріледі. Осы заңды тұлға үшін ақша қаражаттарын төлеу жүргізілмейді.",
    yesCancel: "Ия, болдырмау",
  },
  disabledPaymentModal: {
    title: "Қаражат шығаруды өшіруді растаңыз",
    subtitle: {
      withFullWithdrawal: [
        "«Растау» батырмасын басқанда, бұрын орнатылған төлем сомасы резервтен алынады. Осыдан кейін сіз төлем әдісін өзгерте аласыз немесе төлемге жаңа соманы орната аласыз.",
        "Егер қаражат шығарудың жаңа әдісі таңдалмаса, осы заңды тұлға үшін төлем жүргізілмейді.",
        "Маңызды! Төлемге жаңа соманы орнату тек «Қаражат алуға болады» балансы шегінде ғана мүмкін болады, оның мәні резервті болдырғаннан кейін ағымдағыдан өзгеше болуы мүмкін.",
      ],
      withoutFullWithdrawal: [
        "Өшіргеннен кейін оны қайта қосуға немесе басқа төлем әдісін таңдауға болады.",
        "Егер қаражат шығарудың жаңа әдісі таңдалмаса, осы заңды тұлға үшін төлем жүргізілмейді.",
      ],
    },
  },
};
